import { Container } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledIconContainer = styled(Container)({
  width: "100%",
  marginLeft: "-100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
})

export { StyledIconContainer }
